import ServicesListItem from './ServicesListItem';
import servicesData from '../../data/services.json';
import styles from '../../styles/modules/services/ServicesList.module.scss';

const ServicesList = () => {
  return (
    <div className={styles.list}>
      {servicesData.map((value, index) => (
        <div className={styles.group} key={index}>
          <h3>{value.title}</h3>
          {value.services.map((data, i) => (
            <ServicesListItem text={data.text} details={data.details} key={i} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default ServicesList;
